import React, {
    useCallback,
    useEffect,
    useState,
    useMemo,
    useRef,
} from 'react';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';

import PropTypes from 'prop-types';
import { format, formatISO, parseISO } from 'date-fns';
import { isEmpty, isArray } from 'lodash';
import qs from 'querystring';
import axios from 'axios';
import * as Yup from 'yup';

import { Table } from '~/components';
import { TableSearchListdDef } from '~/componentslocal';
import { RadioGroup, Input, DateTime } from '~/components/Form';
import { t, number, parseDateString } from '~/helpers';
import api from '~/services/api';
import { SelectComplete } from '~/componentslocal'
import { storeData } from '~/store/modules/manutRetrasmitirUnilog/actions';
import * as S from './styles';

export default function ModalRetrasmitir({
    data,
    sending,
    toggleDisabled,
    close
}) {



    const dispatch = useDispatch();

    const { username } = useSelector(state => state.user.profile)
    const { params } = useSelector((state) => state.manutRetrasmitirUnilog);
    const formRef = useRef(null);


    useEffect(() => {
        if (!isEmpty(data))
            handleGetData(data)
    }, [data])


    const handleGetData = useCallback(async (values) => {
        let params = {
            wherefield: ['turn_cod_turn', 'post_cod_posto', 'tipoRel'],
            valuewherefield: [values.turn_cod_turn, values.post_cod_posto, 2],
            typewherefield: ['EQUALS', 'EQUALS', 'EQUALS']

        }

    }, [])

    const handleSubmit = useCallback(async (param) => {
        try {
            toggleDisabled(true)
            const schema = Yup.object().shape({
                msg: Yup.string().required(t('s.geral.validacao.campoobrigatorio'))
                    .matches(/^[a-zA-ZÁ-ú0-9:?!@$%,-.+()\\[\] ]+$/, 'Caractere(s) inválido(s)'),
                user: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),

            });


            await schema.validate(param, {
                abortEarly: false,
            });


            let objSend = {
                rCodigo: data.abas_cod_abas,
                rMaag_Tabela: 'ABASTECIMENTO',
                rMata_Cod_Mata: 2,
                rMaag_Num_Tar_Exec: 1,
                rMaag_Chave: `(POST_COD_POSTO = &#183${data.post_cod_posto}&#183  AND ABAS_COD_ABAS = ${data.abas_cod_abas})`,
                rPost_Cod_Posto: data.post_cod_posto,
                rBico_cod_bico: data.bico_cod_bico.toString(),
                rTurn_cod_turn: '',
                rMaag_Obs: param.msg,
                rMaag_Usua_Sol: param.user,
                rMaag_Usua_Inc: username,
                rNewEmpe_Cod_Emp: data.empe_cod_emp,
                rNewVeic_Cod_Veic: data.veic_cod_veic,
                rNewMoto_cod_moto: '',
                rNewEnvia_Unilog: param.retrasm_cliente,
                rAtualAbas_Vol_Amb: 0.0,
                rAtualAbas_Vol_Ref: 0.0,
                rAtualAbas_Vol_20: 0.0,
                rNF_AlterarVolumes: 'N',
                rNewNumPedido: '',
                rNewNumNfRvt: '',
                rNewNumCTVT: '',
                rNewDataEmissaoNF: '01/01/2021',
                rAtualVolNF: 0.0,
                rAtualVol20NF: 0.0,
                rAtualTemperaturaNF: 0.0,
                rAtualDensidadeNF: 0.0,
                rOldVolNF: 0.0,
                rOldVol20NF: 0.0,
            }

            await dispatch(storeData(objSend, params))
            toggleDisabled(false)
            close();

        } catch (err) {
            toggleDisabled(false)
            const validationErrors = {};
            if (err instanceof Yup.ValidationError) {
                err.inner.forEach((error) => {
                    validationErrors[error.path] = error.message.replace(
                        `${error.path} `,
                        ''
                    );
                });
                formRef.current.setErrors(validationErrors);
            } else {
                toast.error(err)
            }
        }
    }, [data, username, params])


    useEffect(() => {
        if (sending) formRef.current.submitForm();
    }, [sending]);

    return (
        <>
            {!isEmpty(data) && <S.Wrapper
                ref={formRef}
                initialData={{
                    ...data,
                    retrasm_cliente: 'S'
                }}
                onSubmit={handleSubmit}
            >
                <Input name="empe_desc" label="Empresa Atual" disabled />
                <Input name="veic_cod_veic" label="Veículo Atual" disabled />
                <SelectComplete
                    name="user"
                    title="Usuário Solicitante"
                    label="usua_nome"
                    unique="usua_cod_usua"
                    url="usuario"
                />
                <RadioGroup
                    name="retrasm_cliente"
                    label="Retransmitir para Cliente"
                    options={[
                        { label: 'Sim', value: 'S' },
                        { label: 'Não', value: 'N' }]
                    }

                    serialize={(value) => value}
                    row
                    required
                />

                <Input name="msg" label="MSG" multiline rows={7} inputProps={{ maxLength: 500 }} />

            </S.Wrapper >}
        </>

    );
}

ModalRetrasmitir.propTypes = {
    data: PropTypes.objectOf(PropTypes.any).isRequired,
    sending: PropTypes.bool.isRequired,
    visible: PropTypes.bool.isRequired,
    toggleDisabled: PropTypes.func.isRequired,
};
